import { useEffect, useRef, useState } from 'react'
import { Dimensions } from 'react-native'
import { Container } from '../../../comps/Container'
import { useStores } from '../../../data/store'
import { generateRandomNumber } from '../../../util/utill'
import { Carousel } from './Carousel' // assuming Carousel is in a separate file
import { Dots } from './Dots'
import { RenderSplittedTnx } from './RenderSplittedTnx'

const { width } = Dimensions.get('window')
export const SplittedTnxListScreen = () => {
  const flatListRef = useRef(null)
  const [currentIndex, setCurrentIndex] = useState(0)

  const {
    updateTransferredFund,
    feeDetails,
    remittanceUserId,
    mobile,
    beneficiaryId,
    applicableChargesForTransaction,
    splittedTnxs,
    clearSplittedTnxResponses,
  } = useStores((store) => ({
    updateTransferredFund: store.transactionDetails.updateTransferredFund,
    feeDetails: store.transactionDetails.feeDetails,
    remittanceUserId: store.customerDetails.remittanceUserId,
    mobile: store.customerDetails.mobile,
    beneficiaryId: store.beneficiaryDetails.beneficiaryId,
    applicableChargesForTransaction: store.transactionDetails?.applicableChargesForTransaction,
    splittedTnxs: store.transactionDetails?.splittedTnxs,
    clearSplittedTnxResponses: store.transactionDetails?.clearSplittedTnxResponses,
  }))

  useEffect(() => {
    clearSplittedTnxResponses()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleNext = () => {
    console.log('handleNext', currentIndex, splittedTnxs.length - 1)
    if (currentIndex < splittedTnxs.length - 1) {
      const newIndex = currentIndex + 1
      flatListRef.current.scrollToIndex({ index: newIndex })
      setCurrentIndex(newIndex)
    }
  }
  const invoiceNo = useRef(generateRandomNumber(16))

  const renderItem = ({ item, index }) => (
    <RenderSplittedTnx
      item={item}
      index={index}
      handleNext={handleNext}
      isLastItem={index === splittedTnxs.length - 1}
      invoiceNo={invoiceNo?.current}
    />
  )
  return (
    <Container type="refund" showFooter={true} title={`Transaction ${currentIndex + 1}/ ${splittedTnxs.length}`}>
      <Dots currentIndex={currentIndex} length={splittedTnxs?.length} splittedTnxs={splittedTnxs} />
      <Carousel
        data={splittedTnxs}
        renderItem={renderItem}
        flatListRef={flatListRef}
        scrollEnabled={false}
        horizontal
        pagingEnabled={true}
      />
    </Container>
  )
}

const styles = {
  slide: {
    width,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#cce6ff',
    paddingBottom: 100,
  },
  text: {
    fontSize: 24,
    fontWeight: 'bold',
  },
  button: {
    marginTop: 20,
    backgroundColor: '#007aff',
    padding: 12,
    borderRadius: 8,
  },
  buttonText: {
    color: '#fff',
    fontSize: 18,
  },
}
